/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";

const useStyles = makeStyles(styles);

export default function CustomTable(props) {
  const classes = useStyles();
  const { tableHead, tableData, tableHeaderColor } = props;

  const handleOpen = (e, name, id) => {
    onOpen(name, id);
  };

  function onOpen(name, id) {
    props.isOpen(true);
    props.name(name);
    props.reportId(id);
  }



  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    style={{ textAlign: "center" }}
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12 }>
                        {prop}
                      </GridItem>
                    </GridContainer>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.slice().map((prop, key1) => {
            return (
              <TableRow
                key={key1}
                className={classes.tableBodyRow}
                style={{ cursor: "pointer", background: (key1%2 == 0) ? "#c6f9ff" : "#ffffff" }}
                selected={true}
                role="checkbox"
              >
                {tableData[key1][4] !== undefined
                  ? prop.slice(0, 3).map((prop, key) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          key={key}
                          style={{ textAlign: "center" }}
                        ></TableCell>
                      );
                    })
                  : prop.slice(0, 3).map((prop, key) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          key={key}
                          style={{ textAlign: "center" }}
                        >
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              {prop}
                            </GridItem>
                          </GridContainer>
                        </TableCell>
                      );
                    })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
  // tableSelect: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
